import * as tslib_1 from "tslib";
import { Component, Prop, Ref, Vue, Watch } from "vue-property-decorator";
import { getQuestionCategoryList } from "@/api/question";
import Tree from "../../question/components/Tree.vue";
let SystemSelect = class SystemSelect extends Vue {
    constructor() {
        super(...arguments);
        this.questionBankList = [];
        this.filterText = '';
        this.checkedStatus = {};
    }
    get isShowDialog() {
        return this.visible;
    }
    set isShowDialog(_) {
        this.$emit('cancel');
    }
    handleFilterTextChange(text) {
        this.tree.elTree.filter(text);
    }
    created() {
        this.getQuestionClassification();
    }
    setCheckedStatus() {
        this.tree && this.tree.elTree.setCheckedKeys(this.checkedStatus.checkedKeys);
    }
    resetCheckedStatus() {
        this.tree && this.tree.elTree.setCheckedKeys([]);
    }
    async getQuestionClassification() {
        try {
            const res = await getQuestionCategoryList();
            this.questionBankList = res.data.data;
        }
        catch (_) { }
    }
    filterNode(value, nodeData) {
        // console.log("过滤", value, nodeData)
        return !value || -1 !== nodeData.name.indexOf(value);
    }
    handleTreeNodeChecked(checkedNodes, checkedKeys) {
        this.checkedStatus = checkedKeys;
        // console.log(checkedNodes, checkedKeys, "勾选")
    }
    cancel() {
        this.$emit("cancel");
    }
    confirm() {
        console.log("系统抽题第一个弹框的确认");
        if (this.checkedStatus.checkedKeys && this.checkedStatus.checkedKeys.length) {
            const _checkedStatus = JSON.parse(JSON.stringify(this.checkedStatus));
            _checkedStatus.checkedKeys = _checkedStatus.checkedKeys.filter((id) => id !== '0');
            console.log(this.checkedStatus);
            this.$emit("show-system-rule", {
                checkedStatus: _checkedStatus
            });
        }
        else {
            this.$message.error("请先选择题库分类");
        }
    }
};
tslib_1.__decorate([
    Prop({ type: Boolean, default: false })
], SystemSelect.prototype, "visible", void 0);
tslib_1.__decorate([
    Ref()
], SystemSelect.prototype, "tree", void 0);
tslib_1.__decorate([
    Watch('filterText')
], SystemSelect.prototype, "handleFilterTextChange", null);
SystemSelect = tslib_1.__decorate([
    Component({
        name: 'SystemSelect',
        components: {
            Tree
        }
    })
], SystemSelect);
export default SystemSelect;
